<template>
    <div class="calculators">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Calculators</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body class="px-3 pb-3">
                <b-card-header class="border-0">
                    <b-row></b-row>
                </b-card-header>

                <PropertyIncomeEligibleModal :property_income_eligible.sync="modals.property_income_eligible" />
                <MortgageCalculatorModal :mortgage_calculator.sync="modals.mortgage_calculator" />
                <RefinanceCalculatorModal :refinance_calculator.sync="modals.refinance_calculator" />
                <Rule78CalculatorModal :rule78_calculator.sync="modals.rule78_calculator" />
                <LegalFeesCalculatorModal :legal_fees.sync="modals.legal_fees" />
                <RPGTCalculatorModal :rgpt_calculator.sync="modals.rgpt_calculator" />

                <b-row align-h="center" align-v="center" align-content="center">
                    <b-col cols="6" md="2" class="text-center">
                        <!-- <b-overlay
                            show
                            variant="dark"
                            opacity="0.75"
                            blur
                            rounded
                        > -->
                            <div @click="modals.property_income_eligible = true">
                                <b-img v-bind="mainProps" src="/img/calculator/property_income_eligible.png" center rounded alt="Rounded image"></b-img>
                                <p>Property Income Eligible</p>
                            </div>

                            <!-- <template #overlay>
                                <h2 class="text-white">WIP</h2>
                            </template>
                        </b-overlay> -->
                    </b-col>
                    <b-col cols="6" md="2" class="text-center">
                        <div @click="modals.mortgage_calculator = true">
                            <b-img v-bind="mainProps" src="/img/calculator/mortgage.png" center rounded alt="Rounded image"></b-img>
                            <p>Mortgage Calculator</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="2" class="text-center">
                        <div @click="modals.refinance_calculator = true">
                            <b-img v-bind="mainProps" src="/img/calculator/refinance.png" center rounded alt="Rounded image"></b-img>
                            <p>Refinance Calculator</p>
                        </div>

                        <template #overlay>
                            <h2 class="text-white">WIP</h2>
                        </template>
                    </b-col>
                    <b-col cols="6" md="2" class="text-center">
                        <div @click="modals.rule78_calculator = true">
                            <b-img v-bind="mainProps" src="/img/calculator/r78.png" center rounded alt="Rounded image"></b-img>
                            <p>Personal Loan</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="2" class="text-center">
                        <div @click="modals.legal_fees = true">
                            <b-img v-bind="mainProps" src="/img/calculator/legal_fees.png" center rounded alt="Rounded image"></b-img>
                            <p>Legal Fees</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="2" class="text-center">
                        <div @click="modals.rgpt_calculator = true">
                            <b-img v-bind="mainProps" src="/img/calculator/rpgt.png" center rounded alt="Rounded image"></b-img>
                            <p>RPGT</p>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import PropertyIncomeEligibleModal from '@/views/Calculators/CalculatorsModals/PropertyIncomeEligibleModal'
import MortgageCalculatorModal from '@/views/Calculators/CalculatorsModals/MortgageCalculatorModal'
import RefinanceCalculatorModal from '@/views/Calculators/CalculatorsModals/RefinanceCalculatorModal'
import Rule78CalculatorModal from '@/views/Calculators/CalculatorsModals/Rule78CalculatorModal'
import LegalFeesCalculatorModal from '@/views/Calculators/CalculatorsModals/LegalFeesCalculatorModal'
import RPGTCalculatorModal from '@/views/Calculators/CalculatorsModals/RPGTCalculatorModal'
export default {
    components: {
        PropertyIncomeEligibleModal,
        MortgageCalculatorModal,
        RefinanceCalculatorModal,
        Rule78CalculatorModal,
        LegalFeesCalculatorModal,
        RPGTCalculatorModal
    },
    data() {
        return {
            mainProps: { width: 75, height: 75, class: 'cursor-pointer' },
            modals: {
                property_income_eligible: false,
                mortgage_calculator: false,
                refinance_calculator: false,
                rule78_calculator: false,
                legal_fees: false,
                rgpt_calculator: false,
            }
        }
    }
}
</script>